module.exports = __webpack_public_path__ + "static/media/cart-icon.5e10ebb4.svg";